

import _ from 'lodash';

import './financing.scss';
/* @ngInject */
export default function financingController(FinancingFactory, UserData, AccountsFactory, HPRoles, $uibModal, HPAppDetailTypes, HPGeoStates, FinancingConfig) {
    const vm = this;

    vm.currentRates = undefined;
    vm.scheduledRates = undefined;
    vm.effectiveDate = undefined;
    vm.states = {};
    vm.selectedState = undefined;
    vm.financingOptions = {};
    vm.isCompanyAdmin = false;
    vm.isRateChangeScheduled = false;
    vm.phoneNumber = FinancingFactory.getPhoneNumber();
    vm.userData = {};
    vm.premierTier = {};

    init();

    /*= =======================================
    =            Public Functions            =
	======================================== */
    vm.openFinancingTermsModal = function () {
        $uibModal.open({
            templateUrl: 'app/accounts/financing/financingTermsModal/financingTermsModal.html',
            windowClass: 'financing-terms-modal',
            controller: 'FinancingTermsModalController',
            controllerAs: 'financingTermsModal',
            size: 'full-screen',
            animation: false,
        });
    };

    vm.stateClicked = function (state) {
        vm.selectedState = state;
        FinancingFactory.setSelectedState(state);
        vm.currentRates = FinancingFactory.getCurrentRates(state.StateGeoId);
        vm.scheduledRates = FinancingFactory.getScheduledRates(state.StateGeoId);
    };

    vm.allowRateChange = function () {
        return vm.isCompanyAdmin === true && // user is company admin
                !vm.userData.ImpersonatorName && // user is not impersonating
                vm.isRateChangeScheduled === false; // organization does not have a change of rate scheduled
    };

    vm.isEmptyStates = function () {
        return _.isEmpty(vm.states);
    };

    vm.selectedStateHasNewRates = function () {
        return _.find(vm.newRatesConfig.stateGeoIds, stateGeoId => stateGeoId === vm.selectedState.StateGeoId);
    };
    /* -----  End of Public Functions  ------*/


    /*= =======================================
    =            Private Functions           =
    ======================================== */
    function init() {
        vm.newRatesConfig = FinancingConfig.newRates;

        // Get active states
        FinancingFactory.getServiceStates().then((response) => {
            if (!_.isEmpty(response)) {
                vm.states = response;
                vm.selectedState = vm.states[0];
                FinancingFactory.setSelectedState(vm.selectedState);

                // Get default rates for the first state on the list
                getDefaultPlanRates(vm.selectedState);

                // Get Financing Options
                getFinancingOptions();
            }
        });

        FinancingFactory.getPremierTier().then((response) => {
            vm.premierTier = response;
        });

        // Get User Data
        UserData.getUserData().then((data) => {
            vm.userData = data;
            if (data.Roles[0] === HPRoles.COPO_COMPANY_ADMIN.Name) {
                vm.isCompanyAdmin = true;
            }
        });
    }

    function getDefaultPlanRates(state) {
        FinancingFactory.getDefaultPlanRates().then(() => {
            vm.currentRates = FinancingFactory.getCurrentRates(state.StateGeoId);
            vm.isRateChangeScheduled = !_.isEmpty(FinancingFactory.getScheduledRates());
            if (vm.isRateChangeScheduled) {
                const scheduledForSelectedState = FinancingFactory.getScheduledRates(state.StateGeoId);
                if (scheduledForSelectedState) {
                    vm.scheduledRates = scheduledForSelectedState;
                    vm.effectiveDate = scheduledForSelectedState.EffectiveDate;
                } else {
                    vm.scheduledRates = undefined;
                    const firstRate = _.find(FinancingFactory.getScheduledRates(), rate => rate !== undefined);
                    vm.effectiveDate = firstRate.EffectiveDate;
                }
            }
        });
    }

    function getFinancingOptions() {
        FinancingFactory.getFinancingOptions().then((response) => {
            vm.financingOptions = response.data.Data;
        });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/financing/financingController.js